export const reportsList = [
  {
    id: 'aging_work_orders',
    displayName: 'Aging Work Orders',
    description: 'Shows the age of open work orders: 30+ days, 8-29 days, 2-7 days, and less than one day.',
    variants: ['open', 'closed'],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'open_work_order_status',
    displayName: 'Open Work Order Status',
    description: 'Shows the total number of open work orders and whether they are assigned vs unassigned.',
    variants: ['summary', 'detail'],
    filters: ['tech_ids', 'start_date', 'end_date']
  },
  {
    id: 'make_ready_status',
    displayName: 'Make Ready Status',
    description: 'Shows a breakdown of vacant units by status: on notice, vacant, vacant ready, and vacant not ready.',
    variants: [],
    filters: []
  },
  {
    id: 'completed_work_orders',
    displayName: 'Completed Work Orders',
    description: 'Shows completed work orders from a specified time.',
    variants: ['summary', 'detail'],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'work_order_saturation',
    displayName: 'Work Order Saturation',
    description: 'Shows the current open work orders divided by the number of units in the property.',
    variants: [],
    filters: []
  },
  {
    id: 'work_order_category',
    displayName: 'Work Order Category',
    description: 'Shows the breakdown of open and completed work orders by category.',
    variants: ['open', 'completed'],
    filters: ['type', 'start_date', 'end_date']
  },
  {
    id: 'parts_pending',
    displayName: 'Parts Pending',
    description: 'Details the open work orders awaiting parts and which parts are needed.',
    variants: ['summary', 'detail'],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'work_order_by_role',
    displayName: 'Work Order by Role',
    description: 'Shows the open and completed work orders and whether they are assigned to a tech vs vendor.',
    variants: ['open', 'completed'],
    filters: []
  },
  {
    id: 'cancelled_work_orders',
    displayName: 'Canceled Work Orders',
    description: 'Details the person who canceled the work order, when, and why.',
    variants: ['summary', 'detail'],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'work_order_by_level',
    displayName: 'Work Order by Priority',
    description: 'Shows the current open work orders divided by the emergency status.',
    variants: [],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'work_order_time',
    displayName: 'Task Time',
    description: 'Shows the time spend on each work order.',
    variants: ['tech', 'property', 'order',],
    filters: ['start_date', 'end_date', 'tech_ids', 'type', 'completion_status']
  },
  {
    id: 'unit_vacancy',
    displayName: 'Vacant Units',
    description: 'Shows the breakdown of status, days vacant, and make ready progress.',
    variants: [],
    filters: []
  },
  {
    id: 'tech_callback',
    displayName: 'Callbacks by Technician',
    description: 'Details the total number of callbacks and their percentage of completed work orders.',
    variants: [],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'tech_tips',
    displayName: 'Tips by Technician',
    description: ' Shows the total amount earned, withdrawn, and any remaining balance.',
    variants: [],
    filters: ['start_date', 'end_date'],
    renderIf: () => window?.settings?.tech_tipping
  },
  {
    id: 'inspections_status',
    displayName: 'Inspection Overview',
    description: 'Shows detailed information about each inspection based on its status and template.',
    variants: ['all', 'open', 'completed', 'cancelled'],
    filters: ['start_date', 'end_date', 'template_ids', 'status'],
  },
  {
    id: 'make_ready_metrics',
    displayName: 'Make-Ready Metrics',
    description: 'Tracks important make-ready metrics over a time period.',
    variants: [],
    filters: ['start_date', 'end_date']
  },
  {
    id: 'make_ready_task_details',
    displayName: 'Make Ready Task Details',
    description: 'Shows a detailed report about Make Readies.',
    variants: [],
    filters: ['start_date', 'end_date', 'person_ids', 'completion_status'],
  },
  {
    id: 'ratings_and_reviews',
    displayName: 'Ratings & Reviews',
    description: 'Shows all ratings and reviews received by residents.',
    variants: [],
    filters: ['start_date', 'end_date', 'person_ids', 'resident_ids', 'rating'],
  },
  {
    id: 'response_time',
    displayName: 'Response Time Report',
    description: 'Shows the percentage of work orders that are completed on time.',
    variants: ['property', 'tech'],
    filters: ['start_date', 'end_date', 'priority', 'tech_ids', 'completion_time_frame', 'business_days_only', 'exclusions', 'open_orders'],
  },
  {
    id: 'work_order_comparison',
    displayName: 'Work Orders Comparison',
    description: 'Shows a comparison of the number of created and completed work orders between two date ranges.',
    variants: [],
    filters: ['property_ids', 'start_date', 'end_date', 'priority', 'category', 'comparison_start_date', 'comparison_end_date'],
  }
  // {
  //   id: 'average_completion_time',
  //   displayName: 'Average Completion time',
  //   description: 'Shows the average completion time on each tech or property.',
  //   variants: ['tech', 'property'],
  //   filters: ['start_date', 'end_date', 'type']
  // },
].sort((a, b) => a.displayName > b.displayName ? 1 : -1).filter(s => !s.renderIf || s.renderIf())